<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :items="grupos"
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-spacer />
          <v-btn
            v-if="perms.includes('grupo.criar_grupo')"
            depressed
            color="accent"
            :to="{ name: 'grupo-item-formulario', path: 'novo' }"
          >
            <v-icon class="mdi mdi-plus mr-2" />NOVO CADASTRO
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          v-if="perms.includes('grupo.editar_grupo')"
          icon
          small
          text
          @click="editar(item.id)"
        >
          <v-icon class="mdi mdi-pencil" small />
        </v-btn>
        <dialog-confirm
          v-if="perms.includes('grupo.excluir_grupo')"
          titulo="Deletar Grupo Item"
          texto="Confirma a exclusão?"
          @confirmar="deletar(item.id)"
        >
          <v-btn icon small text>
            <v-icon class="mdi mdi-delete" small />
          </v-btn>
        </dialog-confirm>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import DialogConfirm from "../components/DialogConfirm";
export default {
  components: { DialogConfirm },
  data() {
    return {
      headers: [
        { text: "Código", value: "codigo" },
        { text: "Descrição", value: "descricao" },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      loading: false,
      dialogConfirm: false,
    };
  },
  computed: {
    grupos() {
      return this.$store.state.grupoItem.grupoItem;
    },
    perms() {
      return this.$store.state.usuarios.usuarioAtivo.permissoes;
    },
  },
  methods: {
    async listar() {
      this.loading = true;
      try {
        await this.$store.dispatch("grupoItem/listar");
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível carregar a lista de grupos de item",
        });
      }
      this.loading = false;
    },
    async deletar(id) {
      this.loading = true;
      await this.$store.dispatch("grupoItem/deletar", { id });
      this.listar();
    },
    editar(id) {
      this.$router.replace({
        name: "grupo-item-formulario-editar",
        params: { id },
      });
    },
  },
  mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Cadastro de grupos de itens",
    });
    this.listar();
  },
};
</script>
